import { notify } from '../../../utils/airbrake';
/**
 * Send a user event to Mixpanel via our Rails backend.
 * @param payload FormData; payload of event properties to include:
 *   - event_type: name of event, required (string)
 *   - event_action: event action in snake case, required (string)
 *   - event_data: event-specific properties, required (JSON)
 * @returns Promise<any>; Success message or error message from Rails controller
 */
export default async function deliverUserEvent(payload: FormData) {
  const response = await fetch('/api/_private/user_events/deliver', {
    method: 'POST',
    body: payload,
  });

  if (!response.ok) {
    notify(response);
  }

  return response;
}
